import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { useLang } from "@/lib/i18n";

export function InquirySent({ number }) {
  const { t } = useLang();
  return (
    <div data-testid="inquiry-sent" className="mx-auto max-w-2xl px-4 sm:px-6 py-20 rise">
      <MailCheck className="w-14 h-14 text-emerald-400" />
      <h1 className="font-display font-black uppercase text-4xl sm:text-5xl tracking-tight mt-6">{t("inquiry_sent_title")}</h1>
      <p className="text-slate-400 mt-4">{t("inquiry_sent_sub")}</p>
      <div className="mt-8 border border-[#3B4157] px-4 py-3 flex justify-between text-sm">
        <span className="text-slate-400">{t("inquiry_no")}</span><span data-testid="inquiry-number" className="font-mono-x">{number}</span>
      </div>
      <Link to="/catalog" data-testid="inquiry-back-link" className="inline-block mt-10 text-orange-500 uppercase tracking-widest font-display font-semibold">{t("back_shop")} →</Link>
    </div>
  );
}
